module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g0hrz"))).then(() => parcelRequire('fThBo'));